import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"
import { JobDetailModal } from "./JobDetailModal"

/**
 * Globally-mounted host that opens the {@link JobDetailModal} whenever the URL
 * carries a `?job=<id>` param — the deep link a Novu blast notification routes
 * to. Closing strips the param. Mounted once in the Topbar so it works from any
 * page.
 */
export function JobDetailModalHost() {
  const [searchParams, setSearchParams] = useSearchParams()
  const jobId = searchParams.get("job")

  const handleClose = useCallback(() => {
    setSearchParams(
      prev => {
        const next = new URLSearchParams(prev)
        next.delete("job")
        // Carried by the QA report's "Mark irrelevant" / "Mark done" links;
        // consumed by the Meta ads QA rows. Never outlive the modal they target.
        next.delete("irrelevant")
        next.delete("done")
        return next
      },
      { replace: true },
    )
  }, [setSearchParams])

  if (!jobId) return null

  // key remounts the modal (resetting its polling state) when the job changes.
  return <JobDetailModal key={jobId} jobId={jobId} onClose={handleClose} />
}
